import styled from '@emotion/styled'

import OptimizeTheFirstTimeUserExperiencePng2x from './assets/OptimizeTheFirstTimeUserExperience@2x.png'
import OptimizeTheFirstTimeUserExperienceWebp from './assets/OptimizeTheFirstTimeUserExperience.webp'
import OptimizeTheFirstTimeUserExperienceWebp2x from './assets/OptimizeTheFirstTimeUserExperience@2x.webp'
import OptimizeTheFirstTimeUserExperienceWebp3x from './assets/OptimizeTheFirstTimeUserExperience@3x.webp'

const OptimizeTheFirstTimeUserExperienceImage = () => {
  return (
    <Picture>
      <source
        type="image/webp"
        srcSet={`${OptimizeTheFirstTimeUserExperienceWebp}, ${OptimizeTheFirstTimeUserExperienceWebp2x} 2x, ${OptimizeTheFirstTimeUserExperienceWebp3x} 3x`}
      />
      <Image
        src={OptimizeTheFirstTimeUserExperiencePng2x}
        alt="Illustration: Invite a Friend."
        width="544"
        height="510"
        loading="lazy"
      />
    </Picture>
  )
}

export default OptimizeTheFirstTimeUserExperienceImage

const Picture = styled.picture`
  filter: drop-shadow(${({ theme }) => theme.shadows[2]});
`

const Image = styled.img`
  display: block;
  margin-top: 40px;
  ${({ theme }) => theme.breakpoints.down(`md`)} {
    max-height: 344px;
    max-width: 344px;
  }
  ${({ theme }) => theme.breakpoints.up(`md`)} {
    margin: auto;
    max-height: 356px;
    max-width: 356px;
  }
  image-rendering: -webkit-optimize-contrast;
`
